import { FilterOption, IPersonBadge, IProduct, Organisation } from "../../../../common/types";
import { ALL_FILTER_OPTION } from "../../constants";

class SearchInputDataStore {
  private _companyFilterOptions: Array<FilterOption> = [];
  private _standIdFilterOptions: Array<FilterOption> = [];

  updateCompanyFilterOptions(badges: Array<IPersonBadge>, products: Array<IProduct>, organisations: Array<Organisation> = []) {
    const setUpCompanyNames: { [key: string]: boolean } = {};
    const badgeOptions = badges.reduce((acc: Array<FilterOption>, badge) => {
      const companyName = badge.organisation?.displayName;
      if (companyName && !setUpCompanyNames[companyName] && products.find(p => p.sku === badge.productCode)) {
        setUpCompanyNames[companyName] = true;
        acc.push({ label: companyName, value: companyName });
      }
      return acc;
    }, []);

    const organisationOptions = organisations.reduce((acc: Array<FilterOption>, organisation) => {
      const companyName = organisation.companyName;
      if (companyName && !setUpCompanyNames[companyName]) {
        setUpCompanyNames[companyName] = true;
        acc.push({ label: companyName, value: companyName });
      }
      return acc;
    }, []);

    const filterOptions = [...badgeOptions, ...organisationOptions].sort((aOption, bOption) => (aOption.label > bOption.label ? 1 : -1));

    filterOptions.unshift({ value: ALL_FILTER_OPTION, label: "All" });

    this.companyFilterOptions = filterOptions;
  }

  updateStandIdFilterOptions(badges: Array<IPersonBadge>, products: Array<IProduct>) {
    const setUpStandIds: { [key: string]: boolean } = {};
    const filterOptions = badges
      .reduce((acc: Array<FilterOption>, badge) => {
        const standIds = badge.organisation?.standIds || [];
        standIds.forEach((standId: string) => {
          if (!setUpStandIds[standId] && products.find(p => p.sku === badge.productCode)) {
            setUpStandIds[standId] = true;
            acc.push({ label: standId, value: standId });
          }
        });
        return acc;
      }, [])
      .sort((aOption, bOption) => (aOption.label > bOption.label ? 1 : -1));

    filterOptions.unshift({ value: ALL_FILTER_OPTION, label: "All" });

    this.standIdFilterOptions = filterOptions;
  }

  get companyFilterOptions(): Array<FilterOption> {
    return this._companyFilterOptions;
  }

  set companyFilterOptions(value: Array<FilterOption>) {
    this._companyFilterOptions = value;
  }

  get standIdFilterOptions() {
    return this._standIdFilterOptions;
  }

  set standIdFilterOptions(options: Array<FilterOption>) {
    this._standIdFilterOptions = options;
  }
}

export default new SearchInputDataStore();
